import React from 'react';
import { LockIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { valueStack, TOTAL_VALUE, PRICE, CHECKOUT_URL } from '../data/content';
export function PricingSection() {
  return <section id="pricing" aria-labelledby="precios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-184" data-mp="1j8p2pfozthjm">
      <Reveal className="flex flex-col items-center gap-2" data-id="element-185" data-mp="1na0rxk3yg0ra">
        <span className="inline-flex items-center gap-2 rounded-full bg-gold-soft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-186" data-mp="1s93xr6rreb0b">
          <SparklesIcon size={14} data-id="element-187" data-mp="1x6nd6a070ttu" />
          Oferta especial
        </span>
        <h2 id="precios" className="font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-188" data-mp="226i6slbcrxil">
          Todo lo que recibís
        </h2>
      </Reveal>

      <Reveal delay={0.05} className="mx-auto mt-6 max-w-2xl rounded-3xl border border-accent/25 bg-surface p-6 md:p-8" data-id="element-189" data-mp="7utktz6peuop">
        <ul className="divide-y divide-line" data-id="element-190" data-mp="1mihnkwvus5vi">
          {valueStack.map(row => <li key={row.item} className="flex items-center justify-between gap-4 py-3 text-left text-sm md:text-base text-ink" data-id="element-191" data-mp="1hon2pq4ihkuu">
              <span data-id="element-192" data-mp="17t3bvi4t1ccy">{row.item}</span>
              <span className="flex-shrink-0 font-semibold text-ink-muted" data-id="element-193" data-mp="17ppc8hnizh97">
                {row.value}
              </span>
            </li>)}
        </ul>

        <p className="mt-5 text-sm font-bold uppercase tracking-[0.16em] text-ink-subtle" data-id="element-194" data-mp="20hr27s4eurxd">
          Valor total{' '}
          <span className="line-through decoration-danger" data-id="element-195" data-mp="1vfjmqskdgtqa">{TOTAL_VALUE}</span>
        </p>
        <p className="mt-1 text-sm text-ink-muted" data-id="element-196" data-mp="1rf7zr94jehbn">
          Pero hoy no pagás {TOTAL_VALUE}
        </p>

        <p className="mt-4 flex items-baseline justify-center gap-2" data-id="element-197" data-mp="k3iu32ke0l59">
          <span className="font-display text-5xl md:text-6xl font-bold text-accent" data-id="element-198" data-mp="fzjcegndfgab">
            {PRICE}
          </span>
          <span className="text-lg font-semibold text-ink-muted" data-id="element-199" data-mp="hijebfhyjezp">ARS</span>
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-200" data-mp="mfjnhza3sxv1">
          Pago único
        </p>

        <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-6" data-id="element-201" data-mp="7jc3p02lxyga">
          Quiero mi Mega Pack Sabiduría Divina™
        </CtaButton>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-202" data-mp="3uw4n4pguielh">
          <span className="flex items-center gap-1.5" data-id="element-203" data-mp="3i8pei07kah6">
            <LockIcon size={14} className="text-ink-subtle" data-id="element-204" data-mp="3jtj65ep7pdz" />
            Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-205" data-mp="3kwnkyi0syiu9">
            <ZapIcon size={14} className="text-gold" data-id="element-206" data-mp="3pycx60zrh2jx" />
            Acceso digital inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-207" data-mp="3bybt6co79f08">
            <ShieldCheckIcon size={14} className="text-success" data-id="element-208" data-mp="3fzx2jo1izb5o" />
            Garantía 7 días
          </span>
        </div>
      </Reveal>
    </section>;
}